
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/use-mobile';

export const BetaBanner = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Alert variant="default" className="bg-primary/10 border-primary/20 mb-4 md:mb-6">
      <AlertCircle className={`${isMobile ? "h-3.5 w-3.5" : "h-4 w-4"} text-primary`} />
      <AlertDescription className={`${isMobile ? "text-xs" : "text-sm"} text-primary`}>
        {t('beta_message')}
      </AlertDescription>
    </Alert>
  );
};
